import { makeStyles } from '@mui/styles';
import ContainerWithGoBack from '../../UI/ContainerWithGoBack';
import MuralFotoContainer from './MuralFotoContainer';
import { useLocation } from 'react-router';

const useStyles = makeStyles({
    container: {
        padding: '20px',
        backgroundColor: '#fff'
    }
})

const MuralFotoUsuarioContainer = () => {
    const classes = useStyles();
    const location = useLocation();
    const mural = location.state.mural;

    return (
        <ContainerWithGoBack
            className={classes.container}
        >
            <MuralFotoContainer
                mural={mural}
            />
        </ContainerWithGoBack>
    );
}

export default MuralFotoUsuarioContainer;